import get from 'transmute/get';
export default get;